import { Theme } from '@material-ui/core';
import { createStyles } from '@material-ui/styles';
import palette from 'theme/palette';

export default ({ typography }: Theme) =>
  createStyles({
    checkboxCell: {
      padding: '0 0 0 8px',

      '& .MuiCheckbox-root': {
        padding: 0,
      },

      '& span > span > svg': { width: 15, height: 15 },
    },
    loadingAppText: {
      margin: 6,
    },
    connectSkyTitle: {
      margin: 6,
      fontSize: 40,
    },
    buttonHelp: {
      background: 'transparent',
      border: 'none',
      marginTop: 16,
      fontFamily: 'Roboto',
      color: palette.gray,
      fontSize: 14,
      cursor: 'pointer',
    },
    buttonDowloadPlugin: {
      background: palette.deepBlue,
      fontFamily: 'Roboto',
      minWidth: 200,
      marginTop: 10,
      padding: '8px 16px',
      color: palette.white,
      fontSize: 14,
      fontWeight: typography.fontWeightMedium,
      borderRadius: 4,
      '&:hover': {
        background: palette.deepBlue,
        opacity: 0.8,
      },
    },
    spanClickHere: {
      fontWeight: 600,
      color: palette.secondary.main,
      textDecoration: 'none',
    },
    keepGoingContainer: {
      width: '100%',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
    },
    divider: {
      marginTop: 80,
      marginBottom: 10,
      height: 2,
      width: '100%',
      background: palette.deepBlue,
    },
    buttonKeepGoing: {
      background: palette.deepBlue,
      fontFamily: 'Roboto',
      minWidth: 200,
      marginTop: 10,
      padding: '8px 16px',
      color: palette.white,
      fontSize: 14,
      fontWeight: typography.fontWeightMedium,
      borderRadius: 4,
      '&:hover': {
        background: palette.deepBlue,
        opacity: 0.8,
      },
    },
    titleInstallPlugin: {
      margin: '3px 0 15px 0',
    },
    stepsText: {
      margin: 2,
    },
    iconSuccess: {
      width: 15,
      color: palette.status.success,
    },
    appNextStap: {
      fontWeight: 700,
      cursor: 'pointer',
    },
    loadingAppIcon: {
      marginTop: 16,
    },
    loadingContainer: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
    },

    loadingAppLogo: {
      width: 300,
    },
    ButtonOpacity: {
      border: `1px solid ${palette.gray}`,
      color: palette.gray,
      borderRadius: 4,
      padding: 8,
    },
    content: {
      marginTop: 24,
    },
    buttons: {
      '& .MuiButton-root': {
        marginLeft: 16,
      },
    },
    removeButton: {
      background: palette.error.main,
      color: palette.error.contrastText,

      '&:hover': {
        background: palette.error.dark,
      },
    },
    tableRow: {
      width: 50,
      paddingRight: 0,
      paddingLeft: 16,
      '&:hover': {
        background: `${palette.superLightDeepBlue} !important`,
      },
    },
    rowAllRows: {
      width: '64%',
      fontSize: 12,
    },
    rowAllRowsWebApps: {
      width: '35%',
      fontSize: 12,
    },
    ButtonContainer: {
      border: `1px solid ${palette.red}`,
      borderRadius: 4,
      color: palette.red,
      padding: 8,

      '&:hover': {
        opacity: 0.8,
      },
    },
    iconFormat: {
      background: palette.deepBlue,
      color: palette.white,
      borderRadius: '50%',
      padding: 6,
      transform: 'scale(.7)',
    },
    removing: {
      opacity: 0.5,
    },
    statusHeader: {
      justifyContent: 'center',
      fontSize: 12,
      paddingLeft: '22px !important',
    },
    actionHeader: {
      display: 'flex',
      justifyContent: 'center',
    },
    addButtonYellow: {
      marginLeft: 5,
      fontSize: 12,
      padding: '5px 10px',
      backgroundColor: palette.navCompanyContextActions,
      color: palette.white,
      '&:hover': {
        backgroundColor: palette.navCompanyContextActions,
        color: palette.white,
      },
    },
    addButtonGreen: {
      marginLeft: 5,
      fontSize: 12,
      padding: '5px 10px',
      backgroundColor: palette.navAdminActions,
      color: palette.white,
      '&:hover': {
        backgroundColor: palette.navAdminActions,
        color: palette.white,
      },
    },
    addButtonBlue: {
      marginLeft: 5,
      fontSize: 12,
      padding: '5px 10px',
      backgroundColor: palette.navOperatorActions,
      color: palette.white,
      '&:hover': {
        backgroundColor: palette.navOperatorActions,
        color: palette.white,
      },
    },
    addButtonGray: {
      marginLeft: 5,
      fontSize: 12,
      padding: '5px 10px',
      backgroundColor: palette.navSuperAdminActions,
      color: palette.white,
      '&:hover': {
        backgroundColor: palette.navSuperAdminActions,
        color: palette.white,
      },
    },
    removeAppButton: {
      color: palette.error.light,
      padding: 0,
      '& svg': {
        width: 16,
        height: 16,
      },
    },
    rootTabs: {
      width: '100%',
      borderBottom: `1px solid ${palette.lightGray}`,
    },

    tabsYellow: {
      minHeight: 40,
      '& .MuiTabs-indicator': {
        background: palette.navCompanyContextActions,
      },
    },
    tabsGreen: {
      minHeight: 40,
      '& .MuiTabs-indicator': {
        background: palette.navAdminActions,
      },
    },
    tabsGray: {
      minHeight: 40,
      '& .MuiTabs-indicator': {
        background: palette.navSuperAdminActions,
      },
    },
    tabsBlue: {
      minHeight: 40,
      '& .MuiTabs-indicator': {
        background: palette.navOperatorActions,
      },
    },
    iconReport: {
      marginRight: 12,
      fontSize: 14,
      marginBottom: '0px !important',
    },

    tabYellow: {
      fontSize: 12,
      fontWeight: 500,
      minHeight: 35,
      alignItems: 'end',
      color: palette.darkGray,

      '&:hover': {
        textDecoration: 'none',
      },

      '&.Mui-selected': {
        color: palette.navCompanyContextActions,
      },

      '& .MuiTab-wrapper': {
        flexDirection: 'row',
        alignItems: 'none',
      },
    },
    tabGreen: {
      fontSize: 12,
      fontWeight: 500,
      minHeight: 35,
      alignItems: 'end',
      color: palette.darkGray,

      '&:hover': {
        textDecoration: 'none',
      },

      '&.Mui-selected': {
        color: palette.navAdminActions,
      },

      '& .MuiTab-wrapper': {
        flexDirection: 'row',
        alignItems: 'none',
      },
    },
    tabGray: {
      fontSize: 12,
      fontWeight: 500,
      minHeight: 35,
      alignItems: 'end',
      color: palette.darkGray,

      '&:hover': {
        textDecoration: 'none',
      },

      '&.Mui-selected': {
        color: palette.navSuperAdminActions,
      },

      '& .MuiTab-wrapper': {
        flexDirection: 'row',
        alignItems: 'none',
      },
    },
    tabBlue: {
      fontSize: 12,
      fontWeight: 500,
      minHeight: 35,
      alignItems: 'end',
      color: palette.darkGray,

      '&:hover': {
        textDecoration: 'none',
      },

      '&.Mui-selected': {
        color: palette.navOperatorActions,
      },

      '& .MuiTab-wrapper': {
        flexDirection: 'row',
        alignItems: 'none',
      },
    },

    tabPanelContent: {
      width: '100%',
      minWidth: 750,
      '& .MuiFormLabel-root.Mui-disabled': {
        fontSize: 12,
      },
    },
    actions: { marginBottom: 16 },
    addButtonIcon: {
      fontSize: '20px !important',
      '& .MuiButton-startIcon': {
        marginRight: 2,
      },
    },
  });
